import { render } from "./Roadmap.vue?vue&type=template&id=0804f048&scoped=true"
import script from "./Roadmap.vue?vue&type=script&lang=js"
export * from "./Roadmap.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0804f048"

export default script